
<template>
<!-- 选择耗材 -->
    <div>
       <!-- :projectId="form.projectId" -->
        <el-form ref="searchFormRef" :model="query" label-width="80px" size="small">
          <el-row :gutter="20">
            <el-col span="6">
              <el-form-item label="编号" prop="type">
                 <el-input clearable v-model="query.code" maxlength="20" show-word-limit />
              </el-form-item>
            </el-col> 
             <el-col span="6">
              <el-form-item label="耗材名称" prop="name">
                <el-input clearable v-model="query.name" maxlength="20" show-word-limit />
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="类型" prop="partnerId">
                <el-select
                  :disabled="formDisabled"
                  :value="query.typeName"
                  v-model="query.typeName"
                  placeholder="请选择耗材类型"
                  clearable
                  @clear="typeClear"
                  style="width: 100%;"
                >
          <el-option :value="query.typeName" show-all-levels :label="query.typeName">
            <el-tree
              node-key="id"
              :data="treeFormData"
              :props="treeProps"
              :load="typeLazyLoadTree"
              lazy
              @node-click="typeNodeTreeClick"
            >
            </el-tree>
          </el-option>
        </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-button type="primary" @click="search" size="small"> 搜索 </el-button>
              <el-button @click="searchClear" size="small"> 清空 </el-button>
            </el-col>
          </el-row>
        </el-form>
        <!-- <el-radio-group v-model="radio"> -->
        <avue-crud
            :option="option"
            :table-loading="loading"
            :data="data"
            :page.sync="page"
            v-model="selectForm"
            ref="crud"
            @current-change="currentChange"
            @size-change="sizeChange"
            @on-load="onLoad"
            @refresh-change="onLoad">
            
            <template slot="choice" slot-scope="scope">
                <el-radio v-model="radio" :label="scope.row" > {{' '}}</el-radio>
            </template>
           
        </avue-crud>
        <!-- </el-radio-group> -->
         <div class="btnArea" >
            <el-button type="primary"  @click="submitData">确定</el-button>
            <el-button   @click="cancleOperate">取消</el-button>
         </div>
      
        
    </div>
</template>

<script>
import { getListWithNoPicture} from "@/api/crmedical/consumable/consumable";
import {tree} from "@/api/crmedical/consumable/consumabletype";

export default {
  props: ['projectId']
  ,
  data() {
    return {
      treeFormData: [],
       treeProps: {
          //标题
          label: 'name',
          //值
          value: 'id',
          //子节点
          children: 'zones',
          //是否叶子节点
          isLeaf: 'hasChildren',
          //本节点类型key值
          objectType: 'id',
          //本节点类型名
          objectTypeName: 'name',
        },
      radio: '',
       option: {
         
          page: true,
        // height: 'auto',
        align: 'center',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
          column: [
            {
              label: "选择",
              prop: "choice",
              slot:true
            },
            {
              label:'编号',
              prop:'code',

            },
            {
              label: "耗材名称",
              prop: "name",
              
            },
            {
              label: "类型",
              prop: "typeName",
              
            },

            {
              label: "规格",
              prop: "specification",
              
              
            },
            {
              label: "厂家",
              prop: "vender",
             
            },
            {
              label: "价格",
              prop: "price",
              
            },
            {
              label: "计量单位",
              prop: "measuringUnit",
              
              dataType: 'string',
              type: 'select',
              
              dicData: [],
              dicUrl: "/api/v4ward/projectDict/dictionary?code=project_consumable_measuring_unit&projectId="+this.projectId,
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
            },
          ]
        },
        data: [],
      query: {
        code:'',
        name:'',
        typeName:'',
        typeId:''
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      form: {},
    };
  },
  created() {
    
  },
  methods: {
    cancleOperate(){
      this.$emit("cancleOperate")
    },
    typeClear(){
      this.query.typeName =''
      this.query.typeId =""
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
     
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      
    },
    search() {
      this.radio = ''
      this.onLoad()
    },
    radioChange() {
      console.log(this.radio);
    },
    //提交
    submitData() {
      this.$emit('choiceData', this.radio);
      
    },
    searchClear() {
     this.query={
        code:'',
        name:'',
        typeName:'',
        typeId:''
      }
    },
    onLoad(page) {
        page = page || this.page;
        this.loading = true;
        this.query.projectId = this.projectId;
        if (this.query.projectId) {
          getListWithNoPicture(
            Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
          ).then(({data}) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            // this.selectionClear();
          });
        } 
      },
    typeLazyLoadTree(node, resolve) {
        let id;
        if (node.level === 0) {
          id = 0;
        } else {
          id = node.data.id;
        }
        let projectId =this. projectId;
        // if (this.form.projectId) {
        //   projectId = this.form.projectId;
        // } else if(this.query.projectId){
        //   projectId = this.query.projectId;
        // }
        tree({id: id, projectId: projectId}).then(({data}) => {
          if (data instanceof Array) {
            data.forEach(item => {
              item.hasChildren = !item.hasChildren;
            })
          }
          resolve(data);
        });
      },
      typeNodeTreeClick(node) {
        let nodeId = node.id;
        let nodeTitle = node.name;
        
          this.query.typeName = nodeTitle;
          this.query.typeId = nodeId;
          this.$forceUpdate();
       

      },
  },

};
</script>

<style scoped>
.btnArea {
  widows: 100%;
  text-align: right;
  margin-top: 20px;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}
.money{
  text-align: right;
}
</style>
